import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import {
  Avatar,
  Box,
  List,
  ListItemButton,
  Typography,
  Grid,
  Paper,
  Tooltip,
  IconButton,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {
  getAssignedCandidatesAction,
  removeAssignedCandidateAction,
  getcandidateSubmissionsAction,
  selectedSubmissionAction,
  selectedCandidateAction,
  selectedJobAction,
} from "../../redux/action";
import { userSelector } from "../../user-redux/selector";
import { get } from "../../../api";
import url from "../../../api/apisList";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";

export default function AllocatedCandidatesList({ setActiveCandidates }) {
  const dispatch = useDispatch();
  const { candidateSubmissions, selectedCandidate, selectedRecruiter, assignedCandidates, myRecruiters } =
    useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(200);
  const [activeCandidateId, setActiveCandidateId] = useState(null);
  const [inActiveCandidates, setInActiveCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDataReady, setIsDataReady] = useState(false);
  const defaultCandidateSet = useRef(false);

  useEffect(() => {
    if (selectedRecruiter?.recruiter_id) {
      const data = {
        recruiter_id: selectedRecruiter?.recruiter_id,
      };
      //dispatch(getAssignedCandidatesAction(data));
      setIsDataReady(true)
    }
  }, [dispatch, selectedRecruiter?.recruiter_id]);

  const handleRemoveCandidate = (candidateId) => {
    const candidateData = {
      candidate_id: candidateId,
      recruiter_id: selectedRecruiter?.recruiter_id,
    };
    const assignedData = {
      recruiter_id: selectedRecruiter?.recruiter_id,
    };
    dispatch(removeAssignedCandidateAction(candidateData, assignedData));
  };

  const handleClick = (candidate) => {
    const recruiterId = selectedRecruiter?.recruiter_id;
    const candidateId = candidate?.candidate_id;
    const userId = selectedRecruiter?.recruiter_id;
    //console.log("Selected candidate:", candidate?.candidate_id);

    if (userId && candidateId) {
      //console.log("Selected recruiter:", selectedRecruiter);
      dispatch(getcandidateSubmissionsAction(userId, candidateId, page, limit));
      setActiveCandidateId(candidateId);
      dispatch(selectedCandidateAction(candidate));
    } else {
      console.error("Recruiter ID or Candidate ID is undefined");
    }
  };

  const filteredCandidates = useMemo(() => {
    return assignedCandidates.filter(candidate => candidate.status === 1);
  }, [assignedCandidates]);

  useEffect(() => {
    //console.log("assignedCandidates", assignedCandidates)
    setActiveCandidateId(null);
    defaultCandidateSet.current = false;
  }, [assignedCandidates]);


  useEffect(() => {
    if (isDataReady) {
      setActiveCandidates(filteredCandidates || []);

      if (filteredCandidates.length > 0 && !activeCandidateId && !defaultCandidateSet.current) {
        const firstCandidate = filteredCandidates[0];
        handleClick(firstCandidate);
        defaultCandidateSet.current = true; // Prevent infinite loop
      } else if (filteredCandidates.length === 0) {
        // Only clear if not already cleared
        if (activeCandidateId !== null || defaultCandidateSet.current === true) {
          setActiveCandidateId(null);
          dispatch(selectedCandidateAction(null));
          dispatch(getcandidateSubmissionsAction(null, null, page, limit)); // clear submissions
          defaultCandidateSet.current = false;
        }
      }
    }
  }, [filteredCandidates, setActiveCandidates, isDataReady, activeCandidateId, dispatch, page, limit]);



  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box>
            <List>
              {filteredCandidates?.length > 0 && myRecruiters.length > 0 ? (
                filteredCandidates.map((candidate, i) =>
                  candidate?.candidate_name && (
                    <ListItemButton
                      key={i}
                      onClick={() => handleClick(candidate)}
                      selected={candidate.candidate_id === activeCandidateId}
                      style={{
                        backgroundColor:
                          candidate.candidate_id === activeCandidateId
                            ? "#e0e0e0"
                            : "transparent",
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Box display="flex" alignItems="end" gap={1} flex={1}>
                          <Avatar sx={{ fontSize: "14px" }}>
                            {candidate?.candidate_name?.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography
                              variant="body1"
                              style={{ fontSize: "12px", fontWeight: "600" }}
                            >
                              {candidate?.candidate_name}
                            </Typography>
                            <Typography variant="body2" style={{ fontSize: "11px" }}>
                              {candidate?.role}
                            </Typography>
                          </Box>
                        </Box>
                        {selectedRecruiter.user_type_id !== "13" &&
                          <Tooltip title="Deallocate">
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveCandidate(candidate.candidate_id);
                              }}
                            >
                              <RemoveCircleOutlineIcon
                                style={{ color: "#bbb2b2", fontSize: "17px" }}
                              />
                            </IconButton>
                          </Tooltip>}
                      </Box>
                    </ListItemButton>
                  )
                )
              ) : (
                <Typography variant="body2" color="textSecondary" align="center">
                  No candidates assigned to this recruiter.
                </Typography>
              )}
            </List>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}